import { Component, inject } from '@angular/core';
import { Utility } from 'app/core/utility';
import { alert } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';
import { AppInformationService, PortalService } from '../../core/core.module';

@Component({
    selector: 'app-portal-ach-confirmation-dialog',
    templateUrl: './portal-ach-confirmation-dialog.component.html',
    styleUrls: ['./portal-ach-confirmation-dialog.component.scss'],
    standalone: false
})
export class PortalAchConfirmationDialogComponent {
    appInfo = inject(AppInformationService);
    portalService = inject(PortalService);

    result = new Subject<{ success: boolean }>();
    model: any = {};
    ach: any;
    message: string;
    message2: string;
    feeMessage: string;
    processing = false;

    copyAchCode() {
       this.model.codeConfirmation = this.ach.code;
    }

    async save() {
        if (this.processing) return;
        this.processing = true;

        const success = this.valid();
        if (!success) {
            this.processing = false;
            return;
        }

        this.result.next({ success: true });
    }

    cancel() {
        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        }
        return true;
    }

    validateApprovedBy = (e: any) => {
        const approvedBy = e.value;
        return !approvedBy || approvedBy === this.ach.approvedBy;
    };

    validateCode = (e: any) => {
        const code = e.value;
        return !code || this.ach.code === code;
    };
}
